import apiClient, { getApiErrorMessage } from './apiClient';
import { getAuthToken } from '../utils/storage';

const unwrapApiData = (data) => data?.data || data?.Data || data;

export const normalizeUser = (user, fallbackMobile) => {
  const fullName = user?.FullName || user?.fullName || user?.Name || user?.name || '';
  const mobile = user?.PhoneNumber || user?.phoneNumber || fallbackMobile;

  return {
    id: user?.Id || user?.id || `user-${mobile?.slice(-4) || 'guest'}`,
    name: fullName || 'Risman User',
    fullName,
    mobile,
    phoneNumber: mobile,
    avatarUrl: user?.AvatarUrl || user?.avatarUrl || '',
    createdAt: user?.CreatedAt || user?.createdAt || null,
    updatedAt: user?.UpdatedAt || user?.updatedAt || null
  };
};

export const getMeApi = async () => {
  if (!getAuthToken()) {
    throw new Error('Login is required to load profile.');
  }

  try {
    const { data } = await apiClient.get('/Auth/me');
    return normalizeUser(unwrapApiData(data));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Profile request failed.'));
  }
};

export const updateMeApi = async ({ fullName, avatarFile }) => {
  if (!getAuthToken()) {
    throw new Error('Login is required to update profile.');
  }

  try {
    const formData = new FormData();

    if (fullName !== undefined && fullName !== null) {
      formData.append('fullName', fullName);
    }

    if (avatarFile instanceof File) {
      formData.append('avatar', avatarFile);
    }

    const { data } = await apiClient.put('/Auth/me', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return normalizeUser(unwrapApiData(data));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Profile update failed.'));
  }
};

export const sendOtpApi = async (mobile) => {
  try {
    const { data } = await apiClient.post('/Auth/request-otp', {
      PhoneNumber: mobile
    });

    return {
      mobile,
      message: data?.Message || data?.message || 'OTP sent successfully.',
      expiresInSeconds: data?.ExpiresInSeconds || data?.expiresInSeconds || 300
    };
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'OTP request failed.'));
  }
};

export const loginWithOtpApi = async ({ mobile, otpCode }) => {
  try {
    const { data } = await apiClient.post('/Auth/verify-otp', {
      PhoneNumber: mobile,
      Otp: otpCode
    });

    const accessToken = data?.AccessToken || data?.accessToken || null;
    const user = normalizeUser(data?.User || data?.user, mobile);

    return {
      accessToken,
      user
    };
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Login failed.'));
  }
};
